import { AbstractModel } from './abstract.model';

export class ElementTextModel extends AbstractModel {

  public targetObjectId: string;
  public targetObjectType: string;
  public description: string;

  constructor() {
    super();
    this.id = null;
    this.description = '';
  }

}
